<script setup lang="ts">
import type { DialogRootEmits, DialogRootProps } from '@blintz/radix-vue';

import { Dialog, DialogContent } from '@/components/ui/dialog';
import { cn } from '@/utils';
import { useForwardPropsEmits, VisuallyHidden } from '@blintz/radix-vue';

import Command from './Command.vue';

const props = withDefaults(
	defineProps<
		DialogRootProps & {
			showCloseIcon?: boolean;
			title?: string;
			hideTitle?: boolean;
			ignoreTitle?: boolean;
			contentClass?: string;
			overlayClass?: string;
		}
	>(),
	{
		showCloseIcon: true,
		title: '',
		hideTitle: false,
		ignoreTitle: false
	}
);
const emits = defineEmits<DialogRootEmits>();

const forwarded = useForwardPropsEmits(props, emits);
</script>

<template>
	<Dialog v-bind="forwarded">
		<DialogContent
			:class="cn('max-w-none overflow-hidden p-0 shadow-lg', contentClass)"
			:overlay-class="overlayClass"
			:show-close-icon="showCloseIcon"
			data-testid="command-dialog"
		>
			<template v-if="!ignoreTitle">
				<VisuallyHidden v-if="hideTitle || !title" as-child>
					<DialogTitle>{{ title }}</DialogTitle>
				</VisuallyHidden>
				<DialogTitle v-else>{{ title }}</DialogTitle>
			</template>

			<Command
				class="**:[[cmdk-group-heading]]:px-2 **:[[cmdk-group-heading]]:font-medium **:[[cmdk-group-heading]]:text-muted-foreground [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 **:[[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:size-5 **:[[cmdk-input]]:h-12 **:[[cmdk-item]]:px-2 **:[[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:size-5"
			>
				<slot />
			</Command>
		</DialogContent>
	</Dialog>
</template>
